import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  TextField,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { MyContext } from "../../Context/MyContext";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { RegisterFormContext } from "../../Context/RegisterFormContext";
import ButtonsGroup from "./ButtonsGroup";

export default function ScreenThree() {
  const { timezones} = useContext(MyContext);
  const { formData, setFormData, four, six, setAvailableScreens } =
    useContext(RegisterFormContext);


  const handleTimeZoneChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      timeZone: event.target.value,
    }));
  };

  function handlePrev() {
    if (four.current) {
      four.current.scrollIntoView({ behavior: "smooth", block: "center" });

      setTimeout(() => {
        setFormData((prev) => ({
          ...prev,
          timeZone: "",
        }))
          setAvailableScreens((prev) => ({ ...prev, screen5: false }));
        }, 500);
    }
  }

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen6: true }));
    setTimeout(() => {
      if (six.current) {
        six.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }


  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <div style={{ width: "100%", maxWidth: "600px" }}>
          <Typography
            variant="h6"
            style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}
          >
            Select your Time Zone
          </Typography>

          <FormControl
            fullWidth
            style={{ minWidth: "200px", marginTop: "10px" }}
          >
            <InputLabel>Select TimeZone</InputLabel>
            <Select
              value={formData.timeZone || ""}
              onChange={handleTimeZoneChange}
              label="Select TimeZone"
            >
              {timezones.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <ButtonsGroup
          nextDisabled={!formData.timeZone}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
